import { Link } from "react-router-dom";
import { copy } from "../copy";
import Icon from "../components/Icon";
import type { ContestDetail } from "./api";

export default function ContestHeader({ contest }: { contest: ContestDetail }) {
  const c = copy.contest;
  const chips = [contest.challenge, contest.duration, ...contest.tags].filter(
    (t, i, all): t is string => !!t && all.indexOf(t) === i,
  );
  return (
    <header>
      <div className="flex flex-wrap items-center gap-2">
        {contest.format === "versus" && (
          <span className="rounded-full border border-gold/40 bg-ground-raised px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold">
            {c.versus}
          </span>
        )}
        {chips.map((chip) => (
          <span
            key={chip}
            className="rounded-full border border-ground-edge bg-ground-raised px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-chrome-dim"
          >
            {chip}
          </span>
        ))}
        <span
          data-testid="contest-views"
          className="bf-tabular flex items-center gap-1.5 rounded-full border border-ground-edge bg-ground-raised px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-chrome-dim"
        >
          <Icon name="eye" className="h-3 w-3" />
          {c.views(contest.views)}
        </span>
      </div>

      <h1 className="mt-4 break-words font-headline text-4xl uppercase leading-[0.92] tracking-[-0.02em] text-chrome md:text-6xl">
        {contest.title}
      </h1>

      {contest.sponsor && (
        <p className="mt-3 text-[11px] uppercase tracking-[0.14em] text-chrome-dim">
          {c.hostedBy} <span className="font-bold text-chrome">@{contest.sponsor.username}</span>
        </p>
      )}

      {contest.viewer.is_admin && (
        <p className="mt-3">
          <Link
            to={`/admin/contests/${contest.id}`}
            className="bf-focusable text-[11px] font-bold uppercase tracking-[0.16em] text-gold hover:text-gold-light"
          >
            {c.edit}
          </Link>
        </p>
      )}

      {contest.description && (
        <p className="mt-5 max-w-2xl whitespace-pre-line break-words text-sm leading-relaxed text-chrome-dim">
          {contest.description}
        </p>
      )}

      {contest.late_message && (
        <div className="mt-5 rounded-lg border border-gold/30 bg-gold/5 p-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-gold">{c.lateMessage}</p>
          <p className="mt-1.5 text-[13px] leading-relaxed text-chrome">{contest.late_message}</p>
        </div>
      )}
      {contest.cancellation_reason && (
        <div className="mt-5 rounded-lg border border-ground-edge bg-ground-raised p-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-chrome-dim">{c.cancelledReason}</p>
          <p className="mt-1.5 text-[13px] leading-relaxed text-chrome">{contest.cancellation_reason}</p>
        </div>
      )}
    </header>
  );
}
